// extracted by mini-css-extract-plugin
module.exports = {"inputArea_div":"style_inputArea_div__16Rlc","container":"style_container__2mc9u"};